"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMinMaxErrorMessage;

function getMinMaxErrorMessage(input, validatorSettings) {
  function getMinMaxErrorTail() {
    if (Array.isArray(input)) {
      return 'items.';
    }

    if (typeof input === 'string') {
      return 'characters long.';
    }

    return '.';
  }

  return validatorSettings.min === validatorSettings.max ? "Must ".concat(Array.isArray(input) ? 'select' : 'be', " ").concat(validatorSettings.min, " ").concat(getMinMaxErrorTail()) : "Must ".concat(Array.isArray(input) ? 'select' : 'be', " between ").concat(validatorSettings.min, " and ").concat(validatorSettings.max, " ").concat(getMinMaxErrorTail());
}